import { render, staticRenderFns } from "./ApprovalMatrixUsersView.vue?vue&type=template&id=3f3666ee&scoped=true&"
import script from "./ApprovalMatrixUsersView.vue?vue&type=script&lang=ts&"
export * from "./ApprovalMatrixUsersView.vue?vue&type=script&lang=ts&"
import style0 from "./ApprovalMatrixUsersView.vue?vue&type=style&index=0&id=3f3666ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3666ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSelect,VTooltip})
